/***************************************************************************************************
** getCSSPropertyName
***************************************************************************************************/

import { kebabCase } from "change-case";

export default function getCSSPropertyName(name) {
  const [baseName, modifier] = name.split("__");
  const propertyNameParts = ["--", kebabCase(baseName)];

  if (modifier) {
    propertyNameParts.push("__", kebabCase(modifier));
  }

  const propertyName = propertyNameParts.join("");
  return propertyName;
}
